import React from 'react';
import { Card, CardContent } from './ui/card';
import { Check, Palette } from 'lucide-react';
import { useTheme, THEMES } from './ThemeProvider';

export default function ThemeSettings() {
  const { theme, setTheme, themeId } = useTheme();

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-400">
        Choose a background theme for your Gym Notebook experience.
      </p>
      
      <div className="grid grid-cols-2 gap-3">
        {Object.values(THEMES).map((t) => (
          <button
            key={t.id}
            onClick={() => setTheme(t.id)}
            className={`relative rounded-xl overflow-hidden transition-all ${
              themeId === t.id ? 'ring-2 ring-white scale-105' : 'hover:scale-102'
            }`}
            data-testid={`theme-${t.id}`}
          >
            {/* Theme Preview */}
            <div className={`h-20 bg-gradient-to-br ${t.gradient} p-3`}>
              <div className={`w-full h-full rounded-lg ${t.cardBg} ${t.border} border flex items-center justify-center`}>
                <span className={`text-xs font-medium ${t.accent}`}>{t.name}</span>
              </div>
            </div>
            
            {/* Theme Info */}
            <div className="bg-slate-800 p-2">
              <p className="text-white text-sm font-medium">{t.name}</p>
              <p className="text-slate-400 text-xs">{t.description}</p>
            </div>
            
            {/* Selected Indicator */}
            {themeId === t.id && (
              <div className="absolute top-2 right-2 w-6 h-6 bg-white rounded-full flex items-center justify-center">
                <Check className="h-4 w-4 text-slate-900" />
              </div>
            )}
          </button>
        ))}
      </div>
      
      {/* Current Theme Display */}
      <Card className={`${theme.cardBg} ${theme.border} border`}>
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-full ${theme.accentBg} flex items-center justify-center`}>
              <Palette className="h-5 w-5 text-white" />
            </div>
            <div>
              <p className="text-white font-medium">Current: {theme.name}</p>
              <p className="text-slate-400 text-xs">{theme.description}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
